import { useTranslation } from "react-i18next";
import {
  convertDecimalDosage,
  formatDuration,
  getFrequencyText,
} from "./utils";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  medTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: "#000000",

    fontFamily: `"Poppins"`,
  },
  medDetails: {
    fontSize: 14,
    fontWeight: 400,
    color: "#000000",
    paddingBottom: 10,
    fontFamily: `"Poppins"`,
  },
  medFreq: {
    fontSize: 14,
    fontWeight: 400,
    color: "#000000",
    paddingBottom: 10,
    fontFamily: `"Poppins"`,
    textAlign: "center",
  },
  compositionText: {
    fontSize: 12,
    color: "grey",
    paddingBottom: 10,
  },
}));

function MedicinePx({ medicines }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const medicinesView = (medicines) =>
    medicines.map((medicine, index) => (
      <div className="col-12  px-3 py-2" key={index}>
        <div>
          <h4 className={classes.medTitle}>
            {(index + 1).toString() +
              ". " +
              (medicine.drugType ? medicine.drugType + " " : "") +
              " " +
              medicine.drugName +
              (medicine.strength != "" &&
              medicine.strength.replace(/[^0-9.]/g, "") != 0 &&
              medicine.strength.replace(/[0-9.\s]/g, "") != "NA"
                ? " (" + medicine.strength + ")"
                : "")}
          </h4>
          <div className={classes.compositionText}>
            {" "}
            {medicine?.composition}
          </div>

          <div className="row px-2 py2">
            <div className="col-2 d-flex flex-column justify-content-center align-items-center">
              <span className={classes.medFreq}>
                {convertDecimalDosage(medicine.frequency[0])}
              </span>
              <span className={classes.medFreq}>{t("px.morning")}</span>
            </div>
            <div className="col-1 d-flex flex-column ">
              <span className={classes.medFreq}>-</span>
            </div>
            <div className="col-2 d-flex flex-column justify-content-center align-items-center">
              <span className={classes.medFreq}>
                {convertDecimalDosage(medicine.frequency[1])}
              </span>
              <span className={classes.medFreq}>{t("px.afternoon")}</span>
            </div>
            <div className="col-1 d-flex flex-column ">
              <span className={classes.medFreq}>-</span>
            </div>
            <div className="col-2 d-flex flex-column justify-content-center align-items-center">
              <span className={classes.medFreq}>
                {medicine.frequency?.[3]
                  ? convertDecimalDosage(medicine.frequency[3])
                  : 0}
              </span>
              <span className={classes.medFreq}>{t("px.evening")}</span>
            </div>
            <div className="col-1 d-flex flex-column ">
              <span className={classes.medFreq}>-</span>
            </div>
            <div className="col-2 d-flex flex-column justify-content-center align-items-center ">
              <span className={classes.medFreq}>
                {convertDecimalDosage(medicine.frequency[2])}
              </span>
              <span className={classes.medFreq}>{t("px.night")}</span>
            </div>
            {medicine.duration[0] != 0 && (
              <div className="col-12 py-2">
                <span className={classes.medDetails}>
                  {t("px.duration") + ": " + formatDuration(medicine.duration)}
                </span>
              </div>
            )}

            {(medicine.instruction && medicine.instruction != "") ||
            medicine.frequencyPerWeek ? (
              <span className={classes.medDetails}>
                {`${t("px.instruction")} : ${medicine.frequencyPerWeek}${
                  medicine.frequencyPerWeek && medicine.instruction && ". "
                }${medicine.instruction}`}
              </span>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    ));

  return (
    <>
      <div className="row">{medicinesView(medicines)}</div>
    </>
  );
}

export default MedicinePx;
